import Vue from 'vue';
import VueRouter from 'vue-router';
const home = () => import('@/views/home');
const report = () => import('@/views/report');
const appUpload = () => import('@/views/upload');
const fjUpload = () => import('@/views/fjupload');
const dty = () => import('@/views/fjupload/dty');
const diagram = () => import('@/views/diagram');
const vehicle = () => import('@/views/vehicleReport');
const xtUpload = () => import('@/views/fjupload/xintu');


Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: '',
    meta: {
      title: '',
      requireAuth: true,
    },
    component: home
  },{
    path: '/report',
    name: '',
    meta: {
      title: '动力电池安全性能检测报告',
      requireAuth: true,
    },
    component: report
  },{
    path: '/appUpload',
    name: '',
    meta: {
      title: 'NexzDAS下载',
      requireAuth: true,
    },
    component: appUpload
  },{
    path: '/fjUpload',
    name: '',
    meta: {
      title: 'SynTrek下载',
      requireAuth: true,
    },
    component: fjUpload
  },,{
    path: '/xtUpload',
    name: '',
    meta: {
      title: '新途pad下载',
      requireAuth: true,
    },
    component: xtUpload
  },{
    path: '/dtyUpload',
    name: '',
    meta: {
      title: '电太医下载',
      requireAuth: true,
    },
    component: dty
  },
  {
	path: '/diagram',
	name: '',
	meta: {
	  title: '车辆接线图 · 瀚智科技',
	  requireAuth: true,
	},
	component: diagram  
  },
  {
	path: '/vehicleReport',
	name: '',
	meta: {
	  title: '综合诊断报告 · 瀚智科技',
	  requireAuth: true,
	},
	component: vehicle  
  }]

const router = new VueRouter({
    mode: 'history',
    routes
})

router.beforeEach((to,form,next)=>{
	if(to.meta.title){
		document.title = to.meta.title;
	}
	next();
})

export default router